import React from "react";
import {
  Bar,
  CartesianGrid,
  Cell,
  ComposedChart,
  LabelList,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";
import { MeetingsConductedChartOuter } from "./styles";

// s
//   {
//     name: "Sun",
//     count: 30,
//     percentage: '20.35'
//   },
//   {
//     name: "Mon",
//     count: 52,
//       percentage: '20.35'
//   },
//   {
//     name: "Tue",
//     count: 22,
//       percentage: '20.35'
//   },
//   {
//     name: "Wed",
//     count: 38,
//       percentage: '20.35'
//   },
//   {
//     name: "Thu",
//     count: 68,
//       percentage: '20.35'
//   },
//   {
//     name: "Fri",
//     count: 18,
//       percentage: '20.35'
//   },
//   {
//     name: "Sat",
//     count: 28,
//       percentage: '20.35'
//   },
// ];

const colours = [
  "#66D2CE",
  "#386CFA",
  "#4D4D9F",
  "#FFCE51",
  "#51D1FF",
  "#FF8725",
  "#D91656",
];
const AverageMeetingCharts = ({ data = [], marginTop }) => {
  return (
    <MeetingsConductedChartOuter marginTop={marginTop}>
      <ResponsiveContainer width="90%" height="100%">
        <ComposedChart
          layout="vertical"
          width={500}
          height={500}
          data={data}
          margin={{
            top: 10,
            right: 20,
            // bottom: 20,
            // left: 20,
          }}
        >
          <XAxis type="number" />
          <YAxis dataKey="name" type="category" />

          <Bar dataKey="count" barSize={20} label={{ position: "right" }}>
            {data.map((entry, index) => (
              <>
                <Cell
                  cursor="pointer"
                  fill={colours[index]}
                  key={`cell-${index}`}
                />
                {/* <LabelList dataKey="name" content={(props) => {
                            const { x, y, width, height, value } = props;
                            const radius = 10;
                                console.log("value===>",props)
                            return (
                                <g>
                                 <text x={x + width } y={y} >
                                    test
                                </text>
                                </g>
                            );
                            }} /> */}
              </>
            ))}
          </Bar>
        </ComposedChart>
      </ResponsiveContainer>
    </MeetingsConductedChartOuter>
  );
};

export default AverageMeetingCharts;
